import { CircularProgress } from "@mui/material";

export function LoadingButtonText({ loading, text }) {
  return loading ? <CircularProgress color="inherit" size={24} /> : `${text}`;
}
